export default "__VITE_ASSET__BGPQE$vm__"